import qs from 'qs';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint } from 'lib/interfaces/api';
import { JsonSchema } from 'lib/json-schema';

export const accountsApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    resolveVariable: builder.query<
      unknown,
      { accountToken: string; variableDefinitionToken: string }
    >({
      query: async ({ accountToken, variableDefinitionToken }) =>
        SessionClientDashboard.get<JsonSchema>(
          ApiEndpoint.Account,
          accountToken,
          `resolve-variable?${qs.stringify({ 'variable-definition-token': variableDefinitionToken })}`,
        ),
    }),
  }),
});

export const { useLazyResolveVariableQuery } = accountsApi;
